module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "confirm-fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "mt-confirm mt-zindex--topest",
    class: ['mt-modal--small', _vm.type],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "mt-confirm__dialog"
  }, [_c('header', {
    staticClass: "mt-confirm__header"
  }, [_c('mt-icon', {
    attrs: {
      "iconName": _vm.iconName,
      "hover": 'not-set',
      "color": _vm.iconColor
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-confirm__body"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-confirm__footer"
  }, [_c('button', {
    staticClass: "mt-button mt-button--primary mt-button--small",
    on: {
      "click": function($event) {
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))]), _vm._v(" "), _c('button', {
    staticClass: "mt-button mt-button--subtle mt-button--small",
    on: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f50c5e6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/confirm/Confirm.vue
// module id = 9ysq
// module chunks = 0